import { render, staticRenderFns } from "./FormBatiment.vue?vue&type=template&id=6d4fc223"
import script from "./FormBatiment.vue?vue&type=script&lang=js"
export * from "./FormBatiment.vue?vue&type=script&lang=js"
import style0 from "./FormBatiment.vue?vue&type=style&index=0&id=6d4fc223&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports